<template>
    <div class="row">
        <div class="col-md-12">
            <b-form v-if="member">
                <b-row>
                    <b-col md="10">
                        <b-form-group id="addressLabel"
                                      label="Address:"
                                      label-for="address"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="address"
                                    type="text"
                                    v-model="member.address"

                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="address2Label"
                                      label="Address 2:"
                                      label-for="address2"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="address2"
                                    type="text"
                                    v-model="member.address2"
                                    max-length="1"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="cityLabel"
                                      label="City:"
                                      label-for="city"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="city"
                                    type="text"
                                    v-model="member.city"

                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="stateLabel"
                                      label="State:"
                                      label-for="stateName"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="stateName"
                                    type="text"
                                    v-model="member.stateName"

                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="zipCodeLabel"
                                      label="Zip Code:"
                                      label-for="zipCode"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="zipCode"
                                    type="text"
                                    v-model="member.zipCode"

                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="homePhoneLabel"
                                      label="Home Phone:"
                                      label-for="homePhone"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="homePhone"
                                    type="text"
                                    v-model="member.homePhone"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="workPhoneLabel"
                                      label="Work Phone:"
                                      label-for="workPhone"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="workPhone"
                                    type="text"
                                    v-model="member.workPhone"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-form-group id="emailLabel"
                                      label="Email:"
                                      label-for="email"
                                      label-cols-md="6"
                        >
                            <b-form-input
                                    id="email"
                                    type="email"
                                    v-model="member.email"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10">
                        <b-button @click="saveUpdate">Update</b-button>
                        <b-button variant="outline" @click="$router.go(-1)">Cancel</b-button>
                    </b-col>
                </b-row>
            </b-form>

        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import config from '@/config/config'

    export default {
        name: 'AddressChange',
        props: ['member'],
        data: function() {
            return {

            }
        },
        methods: {
            saveUpdate: function() {
                let payload = {
                    cert: this.member.cert,
                    groupCode: this.member.underwriter + this.member.group,
                    changeRequested: this.member
                };

                axios.post(config.apiUrl() + 'member/address/' + this.member.cert, payload).then(response => {
                    if (response.data.msg === 'ok') {
                        this.$router.go(-1);
                    } else {
                        console.error('error in request');
                        this.$router.go(-1);
                    }
                }, err => {
                    console.error('error in request');
                    this.$router.go(-1);
                })
            }
        }
    }
</script>

<style scoped>

</style>
